import { DomSanitizer } from "@angular/platform-browser";
import { environment } from "src/environments/environment";
import { Content, ContentType } from "./API.service";

export function sortByLabel(a, b) {
  var r = /^(\d*)(\.)?(.*)$/;

  var a_exec = r.exec(a.label);
  var b_exec = r.exec(b.label);

  if (a_exec[1] != '') {
    if (b_exec[1] != '') {
      var a_int = parseInt(a_exec[1]);
      var b_int = parseInt(b_exec[1]);

      if (a_int != b_int) {
        return a_int - b_int;
      } else {
        return a_exec[3].trim() > b_exec[3].trim() ? 1 : -1;
      }
    } else {
      return -1;
    }
  } else {
    return a.label.trim() > b.label.trim() ? 1 : -1;
  }
}

export function sortByOrder(a: {order: number}, b : {order: number}) : number {
  return a.order - b.order;
}

export function copyToClipboard(val: string){
  const selBox = document.createElement('textarea');
  selBox.style.position = 'fixed';
  selBox.style.left = '0';
  selBox.style.top = '0';
  selBox.style.opacity = '0';
  selBox.value = val;
  document.body.appendChild(selBox);
  selBox.focus();
  selBox.select();
  document.execCommand('copy');
  document.body.removeChild(selBox);
}

export function getContentSanitizedSrc(content: Content, sanitizer: DomSanitizer) {
  return getSanitizedSrc(content.type, content.value, sanitizer);
}

export function getSanitizedSrc(type: ContentType, value: String, sanitizer: DomSanitizer) {
  if (type == ContentType.IMAGE || type == ContentType.VIDEO || type == ContentType.MODEL){
    return sanitizer.bypassSecurityTrustUrl(environment.cloudfrontUrl + value)
  } 
  var baseUrl = "";
  if (type == ContentType.STREAM_YOUTUBE) {
    baseUrl = "https://www.youtube.com/embed/";
  }
  if (type == ContentType.STREAM_VIMEO){
    baseUrl = "https://player.vimeo.com/video/"
  }
    
  return sanitizer.bypassSecurityTrustResourceUrl(baseUrl + value);
}
